let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aq4wd")).then(() => parcelRequire('aD5wE'));